import React, { useEffect, useState } from 'react';
const testimonials = [{
  name: 'Elena M.',
  quote: 'The Pomegranate extract gives me clean, steady energy without the crash. Total game-changer',
  position: 'top-left'
}, {
  name: 'Rebecca J.',
  quote: 'Finally a Christian supplement brand I can trust. Faith & Fig is a breath of fresh air in my life',
  position: 'bottom-left'
}, {
  name: 'Elizabeth T.',
  quote: 'The Saffron blend keeps me focused and calm all day. Nothing else worked like this.',
  position: 'top-right'
}, {
  name: 'Hannah & Grace',
  quote: 'My mom and I have used F&F for 7 years after trying soo many other brands... ',
  position: 'bottom-right'
}];
const bottleImages = ['https://cdn.shopify.com/s/files/1/0637/8940/0115/files/72532349-ff6e-47c4-9330-04556b782119.png?v=1763794573', 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/d8c379ca-5600-45f5-9690-97da2d6011ee.png?v=1763794573', 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/843ed722-fcab-49c4-9afc-c384ca51f27b.png?v=1763794574', 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/e4ab495b-c6f7-4193-b677-9b7d9923de4f.png?v=1763794573'];
const benefits = ['Inner peace', 'Happiness', 'God-Given Focus', 'Productivity', 'Appetite', 'ADHD Superpowers', 'Prayerful Stillness', 'Calm', 'Immunity', 'Health', 'Energy', 'Vitality', 'Balance', 'Strength', 'Clarity', 'Emotional Balance'];
export const HeroBanner = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentBenefitIndex, setCurrentBenefitIndex] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const scrollToProducts = () => {
    const productsSection = document.getElementById('products-section');
    if (productsSection) {
      productsSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex(prevIndex => (prevIndex + 1) % bottleImages.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const currentBenefit = benefits[currentBenefitIndex];
    const typingSpeed = isDeleting ? 50 : 100;
    const pauseDuration = 1500;
    const timeout = setTimeout(() => {
      if (!isDeleting && displayText === currentBenefit) {
        setTimeout(() => setIsDeleting(true), pauseDuration);
      } else if (isDeleting && displayText === '') {
        setIsDeleting(false);
        setCurrentBenefitIndex(prev => (prev + 1) % benefits.length);
      } else {
        setDisplayText(isDeleting ? currentBenefit.substring(0, displayText.length - 1) : currentBenefit.substring(0, displayText.length + 1));
      }
    }, isDeleting ? typingSpeed : displayText === currentBenefit ? pauseDuration : typingSpeed);
    return () => clearTimeout(timeout);
  }, [displayText, isDeleting, currentBenefitIndex]);
  return <section className="relative min-h-screen w-full overflow-hidden pt-16 md:pt-24 pb-12 md:pb-20 bg-gold/10" data-id="element-89">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-90">
        {/* Top Quote */}
        <div className="text-center mt-4 md:mt-4 mb-1 md:mb-3" data-id="element-91">
          <h2 className="text-2xl md:text-3xl font-light text-text" data-id="element-92">
            "God Created Plants Whose Leaves Heal and Fruits Restore"
          </h2>
          <p className="text-black text-[10px] md:text-xs font-serif font-bold tracking-[0.2em] mt-1 uppercase" style={{
          textShadow: '1px 1px 2px rgba(0,0,0,0.1)'
        }} data-id="element-93">
            Ezekiel 47:12
          </p>
        </div>
        {/* Main Content Grid */}
        <div className="grid lg:grid-cols-2 gap-4 md:gap-8 lg:gap-12 items-center" data-id="element-94">
          {/* Product & Testimonials - Shows first on mobile, right on desktop */}
          <div className="relative flex items-center justify-center min-h-[350px] md:min-h-[500px] lg:min-h-[700px] order-1 lg:order-2" data-id="element-95">
            {/* Product Bottle - Animated Carousel */}
            <div className="relative z-10 w-full max-w-[350px] md:max-w-[450px] lg:max-w-[500px]" data-id="element-96">
              {bottleImages.map((image, index) => <img key={index} src={image} alt={`F&F Vitality+ Supplement Bottle ${index + 1}`} className={`w-full h-auto absolute inset-0 transition-all duration-500 ${index === currentImageIndex ? 'opacity-100 scale-100 blur-0' : 'opacity-0 scale-95 blur-sm'}`} style={{
              filter: index === currentImageIndex ? 'drop-shadow(0 10px 30px rgba(73, 111, 88, 0.15))' : 'none'
            }} data-id="element-97" />)}
              {/* Spacer to maintain layout */}
              <img src={bottleImages[0]} alt="Spacer" className="w-full h-auto opacity-0" data-id="element-98" />
            </div>
            {/* Testimonial Cards - Top Left - Overlapping bottle edge */}
            <div className="absolute top-4 left-2 md:top-8 md:left-4 lg:top-16 lg:left-16 max-w-[140px] lg:max-w-[200px] bg-white rounded-xl lg:rounded-2xl p-3 lg:p-4 shadow-lg border-2 border-text/20 z-20" data-id="element-99">
              <p className="text-[10px] lg:text-xs italic text-text leading-relaxed" data-id="element-100">
                <span className="font-medium not-italic" data-id="element-101">
                  {testimonials[0].name}
                </span>{' '}
                says, "{testimonials[0].quote}"
              </p>
            </div>
            {/* Testimonial Cards - Bottom Left - Overlapping bottle edge */}
            <div className="absolute bottom-4 left-2 md:bottom-8 md:left-4 lg:bottom-16 lg:left-16 max-w-[140px] lg:max-w-[200px] bg-white rounded-xl lg:rounded-2xl p-3 lg:p-4 shadow-lg border-2 border-text/20 z-20" data-id="element-102">
              <p className="text-[10px] lg:text-xs italic text-text leading-relaxed" data-id="element-103">
                <span className="font-medium not-italic" data-id="element-104">
                  {testimonials[1].name}
                </span>{' '}
                reports, "{testimonials[1].quote}"
              </p>
            </div>
            {/* Testimonial Cards - Top Right - Overlapping bottle edge */}
            <div className="absolute top-4 right-2 md:top-8 md:right-4 lg:top-16 lg:right-16 max-w-[140px] lg:max-w-[200px] bg-white rounded-xl lg:rounded-2xl p-3 lg:p-4 shadow-lg border-2 border-text/20 z-20" data-id="element-105">
              <p className="text-[10px] lg:text-xs italic text-text leading-relaxed" data-id="element-106">
                <span className="font-medium not-italic" data-id="element-107">
                  {testimonials[2].name}
                </span>{' '}
                says, "{testimonials[2].quote}"
              </p>
            </div>
            {/* Testimonial Cards - Bottom Right - Overlapping bottle edge */}
            <div className="absolute bottom-4 right-2 md:bottom-8 md:right-4 lg:bottom-16 lg:right-16 max-w-[140px] lg:max-w-[200px] bg-white rounded-xl lg:rounded-2xl p-3 lg:p-4 shadow-lg border-2 border-text/20 z-20" data-id="element-108">
              <p className="text-[10px] lg:text-xs italic text-text leading-relaxed" data-id="element-109">
                <span className="font-medium not-italic" data-id="element-110">
                  {testimonials[3].name}
                </span>{' '}
                says, "{testimonials[3].quote}"
              </p>
            </div>
          </div>
          {/* Text Content - Shows second on mobile, left on desktop */}
          <div className="max-w-xl order-2 lg:order-1" data-id="element-111">
            <h1 className="text-4xl md:text-5xl lg:text-7xl font-light text-text mb-4 lg:mb-6 leading-tight" data-id="element-112">
              Recover Your
              <br data-id="element-113" />
              {displayText}
              <span className="animate-pulse" data-id="element-114">|</span>
            </h1>
            <p className="text-text-light text-base lg:text-lg mb-6 lg:mb-8 leading-relaxed" data-id="element-115">
              Honor your holy temple with the biblical botanicals God provided
              for us. F&F unites God-given ingredients with modern research to
              support your journey through life and faith.
            </p>
            <button onClick={scrollToProducts} className="bg-primary text-white px-8 lg:px-10 py-3 lg:py-4 rounded-full hover:bg-primary/90 transition-all duration-300 text-sm font-medium tracking-wide shadow-lg w-full lg:w-auto" data-id="element-116">
              Try F&F Botanicals+
            </button>
          </div>
        </div>
      </div>
    </section>;
};